import { apiClient } from './client'
import { createWnfClient } from './wnfClient'

export { apiClient, tokenStorage } from './client'
export const wnfClient = createWnfClient(apiClient)
